import { Component, inject } from '@angular/core';
import { SEOService } from '../../services';
import { gender, feedbacks } from '../../../assets/ressources/feedbacks';
import { Event } from '../../models';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { MatAnchor } from '@angular/material/button';
import { EventsCarouselVerticalComponent } from '../../shared/components/events-carousel-vertical/events-carousel-vertical.component';
import { AllEventsCarouselComponent } from '../../shared/components/all-events-carousel/all-events-carousel.component';
import { FanReasonsComponent } from '../components/fan-reasons/fan-reasons.component';
import { FeedbacksCarouselVerticalComponent } from '../../shared/components/feedbacks-carousel-vertical/feedbacks-carousel-vertical.component';
import { AllOrganizersCarouselComponent } from '../../shared/components/all-organizers-carousel/all-organizers-carousel.component';
import { AllPressArticlesCarouselComponent } from '../../shared/components/all-press-articles-carousel/all-press-articles-carousel.component';
import { ROUTES } from '../../routes.constants';

@Component({
  selector: 'app-home-fan',
  templateUrl: './home-fan.component.html',
  styleUrls: ['./home-fan.component.scss'],
  standalone: true,
  imports: [
    TranslocoModule,
    MatAnchor,
    RouterLink,
    EventsCarouselVerticalComponent,
    AllEventsCarouselComponent,
    FanReasonsComponent,
    FeedbacksCarouselVerticalComponent,
    AllOrganizersCarouselComponent,
    AllPressArticlesCarouselComponent,
  ],
})
export class HomeFanComponent {
  private seoService = inject(SEOService);
  private route = inject(ActivatedRoute);

  ROUTES = ROUTES;
  feedbacks: Array<{event: string, gender: gender, name: string, quote: string}> = feedbacks;
  events = new Array<Event>();
  eventsOdd = new Array<Event>();
  eventsEven = new Array<Event>();
  feedbacks1 = new Array<any>();
  feedbacks2 = new Array<any>();
  feedbacks3 = new Array<any>();
  isBrowser = false;

  constructor() {
    // SEO
    const translations = this.route.snapshot.data?.SEOTranslations ?
      this.route.snapshot.data?.SEOTranslations : this.seoService.defaultSEOTranslations;
    this.seoService.updateTitle(translations.title);
    this.seoService.updateDescription(translations.description);
    // fill events arrays
    this.events = this.route.snapshot.data.events?.rows ?? [];
    this.events.forEach((e, i) => {
      if (i % 2 === 0) {
        this.eventsOdd.push(e);
      } else {
        // we unshift last events at the beggining so closest events will be displayed first on reverse carousel
        this.eventsEven.unshift(e);
      }
    });
    // fill feedbacks arrays
    feedbacks.forEach((f, i) => {
      if (i % 3 === 0) {
        this.feedbacks1.push(f);
      } else if (i % 3 === 1) {
        // we unshift last events at the beggining so closest events will be displayed first on reverse carousel
        this.feedbacks2.unshift(f);
      } else {
        this.feedbacks3.push(f);
      }
    });
  }

}
